import {ApplicationData} from '@agenium-ai/agenium-client-sdk/dist/models';
import {useEffect, useMemo} from 'react';
import {useUnderwritingAnalytics} from './useUnderwritingAnalytics';

type ApplicationDecision = 'APPROVED' | 'REFERRED' | 'CANCELLED' | 'DECLINED' | null;

export const useUnderwritingDecision = (
    applicationData: ApplicationData[] | null,
    applicationId: string,
    formId: string,
): ApplicationDecision => {
    const {storeDecision} = useUnderwritingAnalytics({
        applicationId: applicationId,
        formId: formId,
    });

    const decision = useMemo(() => {
        const decision = applicationData?.find((item) => item.key === 'Case_UWDecision_Overall')?.value;

        if (!decision) return null;

        if (decision.match(/\b(refer(red)?)\b/gi)) {
            return 'REFERRED';
        } else if (decision.toLowerCase().match(/postpone|decline(d?)/gi)) {
            return 'DECLINED';
        } else if (decision.toLowerCase().match(/withdrawn|ineligible|incomplete/gi)) {
            return 'CANCELLED';
        } else {
            return 'APPROVED';
        }
    }, [applicationData]);

    useEffect(() => {
        if (decision && formId) {
            storeDecision({decision});
        }
    }, [decision, formId, storeDecision]);

    return decision;
};
